var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreateFile = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#563BCE",
    d: "M7.2 2.4a2.4 2.4 0 0 0-2.4 2.4v6.248q.59-.166 1.2-.222V4.8a1.2 1.2 0 0 1 1.2-1.2H12v4.2a1.8 1.8 0 0 0 1.8 1.8H18v9.6a1.2 1.2 0 0 1-1.2 1.2h-4.32a6.6 6.6 0 0 1-.788 1.2H16.8a2.4 2.4 0 0 0 2.4-2.4V8.897a1.8 1.8 0 0 0-.528-1.272l-4.697-4.698a1.8 1.8 0 0 0-1.272-.527zm10.552 6H13.8a.6.6 0 0 1-.6-.6V3.848zM12 17.4a5.4 5.4 0 1 1-10.8 0 5.4 5.4 0 0 1 10.8 0M7.2 15A.6.6 0 0 0 6 15v1.8H4.2a.6.6 0 1 0 0 1.2H6v1.8a.6.6 0 1 0 1.2 0V18H9a.6.6 0 1 0 0-1.2H7.2z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreateFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/create-file.4ef77041.svg";